import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { InputSelectionStyles, applySelectCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-select',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxSelectStyleDirective {
  componentStyle = input<{
    style: InputSelectionStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applySelectCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
